import React, {useContext} from 'react'
import {Droppable} from 'react-drag-and-drop'
import {BarcodeLabelEditorContext} from '../../context/BarcodeLabelEditor'
import useStyles from './BarcodeLabelDropArea.styles'
import BarcodeLabelItem from '../BarcodeLabelItem'

function BarcodeLabelDropArea(props) {
  const classes = useStyles()
  const {state, addItem, updateItem, removeItem} = useContext(BarcodeLabelEditorContext)
  const {labelItems = []} = state

  function onDrop(item, e) {
    item = JSON.parse(item.dragitem)

    var target = e.target || e.srcElement
    var rect = target.getBoundingClientRect()
    item[Object.keys(item)[0]].position.left = e.clientX - rect.left
    item[Object.keys(item)[0]].position.top = e.clientY - rect.top
    addItem({item: item})
  }

  function updateDndItem(item, index) {
    updateItem({item, index})
  }

  function removeDndItem(item, index) {
    removeItem({item, index})
  }

  return (
    <Droppable
      types={['dragitem', 'groupitem']} // <= allowed drop types
      onDrop={onDrop}
      className={classes.root}
      style={{height: props.height, width: props.width}}
      data-can-deselect={true}
      id="drop_area"
    >
      <React.Fragment>
        {labelItems.map((item, index) => {
          return (
            <BarcodeLabelItem
              key={item.key}
              item={item}
              index={index}
              focused={item.focused}
              updateDndItem={updateDndItem}
              removeDndItem={removeDndItem}
            ></BarcodeLabelItem>
          )
        })}
      </React.Fragment>
    </Droppable>
  )
}
export default BarcodeLabelDropArea
